/* RESPONSIBLE TEAM: team-fin-voice */
import ApplicationAdapter from '../application';

export default class FinVoicePronunciationAdapter extends ApplicationAdapter {
  pathForType() {
    return 'fin_voice/pronunciations';
  }
}
